import React from 'react';
const ActionBlurLoader = ({fixed, className})=> {
    return (
        <div className={`pre-blur-loader ${className}`} id="pre-blur-loader" style={{
            position: fixed?'fixed': 'absolute'
        }}>
            <div className="pre-blur-loader-div">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            </div>
        </div>
    )
};

export default ActionBlurLoader;